import { useEffect, useState, useCallback } from "react"
import { useNavigate } from "react-router-dom";
import useErroPadrao from '../../../hooks/useErroPadrao';
import useFlashMessage from '../../../hooks/useFlashMessages';
import useLead from '../../../hooks/useLead';
import useHelp from '../../../hooks/useHelp';
import { CHAVE_TOKEN, dataBR, linkWhatsApp } from "../../../utils/formata";
import { Vazio, EsqueletoCartoes, EsqueletoLista } from "../../Components/Estado";

const STATUS = [
    { valor: "pendente", rotulo: "Pendente", plural: "Pendentes", cor: "#9aa5b5" },
    { valor: "enviado", rotulo: "Enviado", plural: "Enviados", cor: "#4da3ff" },
    { valor: "entregue", rotulo: "Entregue", plural: "Entregues", cor: "#d4af37" },
    { valor: "respondeu", rotulo: "Respondeu", plural: "Responderam", cor: "#43d17c" },
    { valor: "descartado", rotulo: "Descartado", plural: "Descartados", cor: "#ff6b6b" },
    { valor: "cliente", rotulo: "Cliente", plural: "Clientes", cor: "#b98bff" },
];

const NICHOS = [
    "Salão de beleza", "Barbearia", "Manicure/Estética", "Lanchonete", "Restaurante",
    "Pizzaria", "Pastelaria", "Sorveteria", "Food truck", "Padaria", "Açougue",
    "Mercadinho", "Conveniência", "Hortifruti", "Distribuidora de bebidas", "Bar",
    "Lavação", "Borracharia", "Oficina mecânica", "Petshop", "Academia", "Papelaria",
    "Assistência técnica", "Outro",
];

const corDoStatus = (s) => STATUS.find((x) => x.valor === s)?.cor || "#9aa5b5";
const rotuloDoStatus = (s) => STATUS.find((x) => x.valor === s)?.rotulo || s;

const LEAD_VAZIO = { nome: "", telefone: "", nicho: NICHOS[0], cidade: "Itajaí" };

const POR_PAGINA = 25;

const MODOS_ENVIO = [
    { valor: "misto", rotulo: "Misturar", icone: "bi bi-shuffle", dica: "Metade com a arte, metade só texto — parece menos disparo automático" },
    { valor: "foto", rotulo: "Com foto", icone: "bi bi-image", dica: "Todo convite sai com a arte e uma breve apresentação" },
    { valor: "texto", rotulo: "Só texto", icone: "bi bi-chat-text", dica: "Todo convite sai só escrito" },
];

export default function ProspeccaoPainel() {
    const [leads, setLeads] = useState([]);
    const [config, setConfig] = useState(null);
    const [novoLead, setNovoLead] = useState(LEAD_VAZIO);
    const [textoImport, setTextoImport] = useState("");
    const [nomeArquivo, setNomeArquivo] = useState("");
    const [resultadoImport, setResultadoImport] = useState("");
    const [busca, setBusca] = useState("");
    const [filtroStatus, setFiltroStatus] = useState(null);
    const [filtroNicho, setFiltroNicho] = useState("");
    const [pagina, setPagina] = useState(1);
    const [telefoneTeste, setTelefoneTeste] = useState("");
    const [enviandoTeste, setEnviandoTeste] = useState(false);
    const [carregando, setCarregando] = useState(true);
    const [salvandoConfig, setSalvandoConfig] = useState(false);
    const [adicionando, setAdicionando] = useState(false);
    const [importando, setImportando] = useState(false);
    const [marcando, setMarcando] = useState(false);
    const [disparando, setDisparando] = useState(false);
    const [salvandoModo, setSalvandoModo] = useState(false);
    const [avisoDisparo, setAvisoDisparo] = useState("");
    const [robo, setRobo] = useState(null);
    const [filtrosCristal, setFiltrosCristal] = useState({nicho: "", cidade: "", uf: "SC", limite: 100});
    const [buscandoCristal, setBuscandoCristal] = useState(false);
    const [resultadoCristal, setResultadoCristal] = useState("");
    const { listarLeads, cadastrarLead, atualizarLead, deletarLead, importarLeads, selecionarLeads, pedirDisparo, buscarNoCristal, configProspeccao, salvarConfigProspeccao, enviarTesteProspeccao } = useLead();
    const { statusRobo } = useHelp();
    const { setErroPadrao } = useErroPadrao();
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigate();

    const carregar = useCallback(() => {
        setCarregando(true);
        Promise.all([listarLeads(), configProspeccao()])
            .then(([lista, cfg]) => {
                setLeads(lista || []);
                setConfig(cfg || { ativa: false, limiteDia: 10, horaInicio: "09:00", horaFim: "18:00", mensagemExtra: "" });
            })
            .catch((error) => setErroPadrao(error))
            .finally(() => setCarregando(false));
    }, [listarLeads, configProspeccao, setErroPadrao]);

    const recarregarLeads = useCallback(() => {
        listarLeads()
            .then((lista) => setLeads(lista || []))
            .catch((error) => setErroPadrao(error));
    }, [listarLeads, setErroPadrao]);

    useEffect(() => {
        if (!localStorage.getItem(CHAVE_TOKEN)) {
            navigate("/login");
            return;
        }
        carregar();
    }, [carregar, navigate]);

    // Status do robô pra reconectar aqui mesmo. O QR do WhatsApp vive ~20s, então buscamos
    // a cada 5s enquanto a página está aberta — mas só enquanto NÃO está conectado, pra não
    // ficar batendo à toa quando está tudo certo.
    useEffect(() => {
        let vivo = true;
        const buscar = () => statusRobo().then((r) => { if (vivo) setRobo(r); }).catch(() => {});
        buscar();
        const id = setInterval(buscar, 5000);
        return () => { vivo = false; clearInterval(id); };
    }, [statusRobo]);

    // filtrou/buscou → volta pra primeira página (senão fica numa página que não existe mais)
    useEffect(() => { setPagina(1); }, [busca, filtroStatus, filtroNicho]);

    function handleSalvarConfig(e) {
        e.preventDefault();
        setSalvandoConfig(true);
        salvarConfigProspeccao(config)
            .then((resp) => {
                if (resp.config) setConfig(resp.config);
                setFlashMessage(resp.message || "Configuração salva!", "success");
            })
            .catch((error) => setErroPadrao(error))
            .finally(() => setSalvandoConfig(false));
    }

    function handleEnviarTeste(e) {
        e.preventDefault();
        const tel = telefoneTeste.replace(/\D/g, "");
        if (tel.length < 10) { setFlashMessage("Coloca um WhatsApp com DDD (ex: 47 9xxxx-xxxx).", "error"); return; }
        setEnviandoTeste(true);
        enviarTesteProspeccao(telefoneTeste, "seu negócio")
            .then((resp) => setFlashMessage(resp.message || "Teste enviado!", "success"))
            .catch((error) => setErroPadrao(error))
            .finally(() => setEnviandoTeste(false));
    }

    function handleAdicionar(e) {
        e.preventDefault();
        setAdicionando(true);
        cadastrarLead(novoLead)
            .then((resp) => {
                setFlashMessage(resp.message || "Lead adicionado!", "success");
                setNovoLead({ ...LEAD_VAZIO, nicho: novoLead.nicho, cidade: novoLead.cidade });
                recarregarLeads();
            })
            .catch((error) => setErroPadrao(error))
            .finally(() => setAdicionando(false));
    }

    // Planilha exportada vem com vírgula, ponto-e-vírgula ou tabulação, e campos entre aspas
    function separarCampos(linha) {
        const separador = (linha.match(/;/g) || []).length >= (linha.match(/,/g) || []).length
            ? (linha.includes(";") ? ";" : (linha.includes("\t") ? "\t" : ","))
            : ",";
        const campos = [];
        let atual = "";
        let dentroDeAspas = false;
        for (let i = 0; i < linha.length; i++) {
            const c = linha[i];
            if (c === '"') {
                if (dentroDeAspas && linha[i + 1] === '"') { atual += '"'; i++; }
                else dentroDeAspas = !dentroDeAspas;
            } else if (c === separador && !dentroDeAspas) {
                campos.push(atual.trim());
                atual = "";
            } else {
                atual += c;
            }
        }
        campos.push(atual.trim());
        return campos;
    }

    // O Cristal muda a ordem das colunas a cada exportação. Em vez de exigir
    // Nome;Telefone;Nicho;Cidade, a gente lê o cabeçalho e acha cada coluna pelo nome.
    const COLUNAS = {
        nome: /^(nome|empresa|raz[ãa]o ?social|nome ?fantasia|estabelecimento)$/,
        telefone: /^(whats(app)?|telefone|celular|fone|contato)$/,
        nicho: /^(tipo|nicho|segmento|categoria|ramo|atividade)$/,
        cidade: /^(cidade|munic[íi]pio|local)$/,
    };

    function mapearCabecalho(campos) {
        const limpos = campos.map((c) => (c || "").toLowerCase().trim());
        const mapa = {};
        limpos.forEach((titulo, i) => {
            Object.entries(COLUNAS).forEach(([chave, regex]) => {
                if (!regex.test(titulo)) return;
                // WhatsApp ganha de Telefone: vem com DDI e sem formatação
                if (chave === "telefone" && mapa.telefone !== undefined && !/whats/.test(titulo)) return;
                mapa[chave] = i;
            });
        });
        return mapa.nome !== undefined && mapa.telefone !== undefined ? mapa : null;
    }

    // "5504974336047" é 55 + 047 + número: o zero do DDD sobra e o WhatsApp recusa.
    // Fixo (começa em 2..5) também não recebe convite — não adianta importar.
    function normalizarTelefone(bruto) {
        let d = String(bruto || "").replace(/\D/g, "");
        if (d.startsWith("55") && d.length > 12 && d[2] === "0") d = "55" + d.slice(3);
        if (!d.startsWith("55") && (d.length === 10 || d.length === 11)) d = "55" + d;
        if (d.length !== 12 && d.length !== 13) return "";

        const ddd = Number(d.slice(2, 4));
        const assinante = d.slice(4);
        if (ddd < 11 || ddd > 99) return "";
        if (assinante.length === 9 && assinante[0] !== "9") return "";
        if (assinante.length === 8 && !/[6-9]/.test(assinante[0])) return "";
        return d;
    }

    function handleImportar() {
        const linhas = textoImport.split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
        if (linhas.length === 0) return;

        const mapa = mapearCabecalho(separarCampos(linhas[0]));
        const corpo = mapa ? linhas.slice(1) : linhas;

        let invalidas = 0;
        const lista = [];
        corpo.forEach((linha) => {
            const campos = separarCampos(linha);
            const pega = (chave, posicao) => (mapa ? campos[mapa[chave]] : campos[posicao]) || "";

            const nome = String(pega("nome", 0)).trim();
            const telefone = normalizarTelefone(pega("telefone", 1));
            if (!nome || !telefone) { invalidas++; return; }

            lista.push({
                nome,
                telefone,
                nicho: String(pega("nicho", 2)).trim() || "Outro",
                cidade: String(pega("cidade", 3)).trim() || "Itajaí",
            });
        });

        if (lista.length === 0) {
            setResultadoImport(`0 importados, ${invalidas} ignorados`);
            return;
        }

        setImportando(true);
        importarLeads(lista)
            .then((resp) => {
                setResultadoImport(`${resp.importados || 0} importados, ${(resp.ignorados || 0) + invalidas} ignorados`);
                setTextoImport("");
                recarregarLeads();
            })
            .catch((error) => setErroPadrao(error))
            .finally(() => setImportando(false));
    }

    // Marcar um lead. Atualizo a linha na hora e só depois confirmo no servidor —
    // marcar 20 empresas esperando resposta de rede a cada clique é insuportável.
    function alternarSelecao(lead, marcado) {
        setLeads((atuais) => atuais.map((l) => (l.id === lead.id ? {...l, selecionado: marcado} : l)));
        selecionarLeads([lead.id], marcado).catch((error) => {
            setLeads((atuais) => atuais.map((l) => (l.id === lead.id ? {...l, selecionado: !marcado} : l)));
            setErroPadrao(error);
        });
    }

    function marcarVisiveis(marcado) {
        const ids = visiveis.filter((l) => l.status === "pendente").map((l) => l.id);
        if (!ids.length) return;
        setMarcando(true);
        selecionarLeads(ids, marcado)
            .then(() => setLeads((atuais) => atuais.map((l) => (ids.includes(l.id) ? {...l, selecionado: marcado} : l))))
            .catch((error) => setErroPadrao(error))
            .finally(() => setMarcando(false));
    }

    function mudarModoEnvio(modo) {
        const anterior = config?.modoEnvio || "misto";
        if (modo === anterior) return;
        setConfig((c) => ({...c, modoEnvio: modo}));
        setSalvandoModo(true);
        salvarConfigProspeccao({modoEnvio: modo})
            .catch((error) => {
                setConfig((c) => ({...c, modoEnvio: anterior}));
                setErroPadrao(error);
            })
            .finally(() => setSalvandoModo(false));
    }

    function handleDisparar() {
        if (!marcadosPendentes) return;
        setDisparando(true);
        setAvisoDisparo("");
        pedirDisparo(marcadosPendentes)
            .then((r) => setAvisoDisparo(`Pedido enviado: ${r.quantos} convite(s). O robô começa em até 30 segundos e espaça cada envio pra não parecer spam.`))
            .catch((error) => setErroPadrao(error))
            .finally(() => setDisparando(false));
    }

    function handleBuscarCristal() {
        setBuscandoCristal(true);
        setResultadoCristal("");
        buscarNoCristal(filtrosCristal)
            .then((r) => {
                setResultadoCristal(r.message || "Busca concluída.");
                recarregarLeads();
            })
            .catch((error) => setErroPadrao(error))
            .finally(() => setBuscandoCristal(false));
    }

    function mudarStatus(lead, status) {
        atualizarLead(lead.id, { status })
            .then(recarregarLeads)
            .catch((error) => setErroPadrao(error));
    }

    function handleExcluir(lead) {
        if (!window.confirm(`Excluir o lead "${lead.nome}" de vez?`)) return;
        deletarLead(lead.id)
            .then(recarregarLeads)
            .catch((error) => setErroPadrao(error));
    }

    const contagem = (status) => leads.filter((l) => l.status === status).length;

    // nichos que existem nos leads, com quantidade, em ordem alfabética — pro dropdown
    const nichosDisponiveis = Object.entries(
        leads.reduce((acc, l) => {
            const n = (l.nicho || "Sem nicho").trim();
            acc[n] = (acc[n] || 0) + 1;
            return acc;
        }, {})
    ).sort((a, b) => a[0].localeCompare(b[0], "pt-BR"));

    const visiveis = leads
        .filter((l) => {
            const casaBusca = !busca || `${l.nome} ${l.telefone} ${l.nicho || ""}`.toLowerCase().includes(busca.toLowerCase());
            const casaFiltro = !filtroStatus || l.status === filtroStatus;
            const casaNicho = !filtroNicho || (l.nicho || "Sem nicho").trim() === filtroNicho;
            return casaBusca && casaFiltro && casaNicho;
        })
        // agrupa visualmente por nicho (mesmo nicho fica junto, alfabético)
        .sort((a, b) => (a.nicho || "").localeCompare(b.nicho || "", "pt-BR") || (a.nome || "").localeCompare(b.nome || "", "pt-BR"));

    const pendentesVisiveis = visiveis.filter((l) => l.status === "pendente").length;
    const marcadosPendentes = leads.filter((l) => l.selecionado && l.status === "pendente").length;

    // Paginação: com 500+ leads a lista vira um rolão. Mostra POR_PAGINA por vez.
    const totalPaginas = Math.max(1, Math.ceil(visiveis.length / POR_PAGINA));
    const paginaAtual = Math.min(pagina, totalPaginas);
    const visiveisPagina = visiveis.slice((paginaAtual - 1) * POR_PAGINA, paginaAtual * POR_PAGINA);

    return (
        <div className="pagina">
            <h2 className="he-titulo">Prospecção <span className="he-dourado">Itajaí e Região</span></h2>
            <p className="subtitulo-pagina">
                O robô convida até {config?.limiteDia ?? 20} negócios por dia — <strong className="he-dourado">só os que você marcar</strong> 💛
            </p>

            {/* Conexão do robô — escanear/reconectar sem sair da prospecção */}
            {robo && (
                <div style={{
                    marginTop: 14, marginBottom: 6, padding: "14px 16px", borderRadius: 14,
                    background: "#0f1e2e", border: `1px solid ${robo.conectado ? "#2ecc71" : (robo.vivo ? "#e0a800" : "#e74c3c")}`,
                    display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap",
                }}>
                    <div style={{display: "flex", alignItems: "center", gap: 10}}>
                        <span style={{
                            width: 12, height: 12, borderRadius: "50%", display: "inline-block",
                            background: robo.conectado ? "#2ecc71" : (robo.vivo ? "#e0a800" : "#e74c3c"),
                            boxShadow: `0 0 10px ${robo.conectado ? "#2ecc71" : (robo.vivo ? "#e0a800" : "#e74c3c")}`,
                        }}/>
                        <strong style={{color: robo.conectado ? "#2ecc71" : (robo.vivo ? "#e0a800" : "#e74c3c")}}>
                            {robo.conectado ? "WhatsApp conectado" : (robo.vivo ? "Robô ligado — falta escanear o WhatsApp" : "Robô desligado")}
                        </strong>
                    </div>

                    {!robo.conectado && robo.qrImagem && (
                        <div style={{display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap"}}>
                            <img src={robo.qrImagem} alt="QR do WhatsApp" style={{width: 200, height: 200, borderRadius: 10, background: "#fff", padding: 6}}/>
                            <ol style={{margin: 0, paddingLeft: 18, color: "#c9d4e2", fontSize: "0.9rem", lineHeight: 1.7}}>
                                <li>Abra o <strong>WhatsApp da Help</strong> no celular</li>
                                <li>Menu ⋮ &rsaquo; <strong>Aparelhos conectados</strong></li>
                                <li>Toque em <strong>Conectar um aparelho</strong></li>
                                <li>Aponte a câmera neste QR 👈</li>
                            </ol>
                        </div>
                    )}
                    {!robo.conectado && !robo.qrImagem && (
                        <span style={{color: "#9aa5b5", fontSize: "0.9rem"}}>Gerando o QR… aguarde uns segundos e ele aparece aqui.</span>
                    )}
                    {robo.conectado && (
                        <span style={{color: "#9aa5b5", fontSize: "0.9rem"}}>Está tudo certo — o QR só aparece aqui se a conexão cair.</span>
                    )}
                </div>
            )}

            {carregando
                ? <>
                    <div style={{marginTop: 18}}><EsqueletoCartoes quantidade={6}/></div>
                    <div style={{marginTop: 16}}><EsqueletoLista quantidade={3}/></div>
                  </>
                : <>
                    {/* Estatísticas — toque filtra a lista */}
                    <div className="secao-titulo"><i className="bi bi-bar-chart-steps"></i> Funil</div>
                    <div className="cards-estatistica">
                        {STATUS.map((s) => {
                            const ativo = filtroStatus === s.valor;
                            return (
                                <button key={s.valor} type="button" className="card-estat"
                                    aria-pressed={ativo}
                                    title={ativo ? "Tocar de novo mostra todos" : `Ver só os ${s.plural.toLowerCase()}`}
                                    onClick={() => setFiltroStatus(ativo ? null : s.valor)}
                                    style={{
                                        "--cor-acento": s.cor,
                                        borderColor: ativo ? s.cor : undefined,
                                        boxShadow: ativo ? `0 0 0 1px ${s.cor}, 0 8px 22px ${s.cor}40` : undefined,
                                    }}>
                                    <div className="estat-numero" style={{color: s.cor}}>
                                        {contagem(s.valor)}
                                    </div>
                                    <div className="estat-rotulo" style={{color: ativo ? s.cor : undefined}}>
                                        {s.plural}
                                    </div>
                                </button>
                            );
                        })}
                    </div>

                    {/* Enviar teste pro WhatsApp — ver como a mensagem chega */}
                    <div className="secao-titulo"><i className="bi bi-whatsapp"></i> Testar a mensagem</div>
                    <form onSubmit={handleEnviarTeste} className="he-card form-mobile" style={{marginBottom: "1.2em", borderColor: "rgba(67,209,124,0.4)"}}>
                        <h6 className="he-titulo" style={{margin: 0, color: "#43d17c"}}><i className="bi bi-send-check"></i> Enviar teste pro seu WhatsApp</h6>
                        <p style={{color: "#9aa5b5", fontSize: "0.85em", margin: "6px 0 10px"}}>
                            Manda a mensagem da prospecção pro número que você quiser, pra ver exatamente como chega pro cliente. O robô entrega em até 1 minuto.
                        </p>
                        <div style={{display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center"}}>
                            <input className="form-control form-control-sm" style={{maxWidth: 260}} inputMode="tel"
                                placeholder="Seu WhatsApp com DDD (ex: 47 99999-8888)"
                                value={telefoneTeste} onChange={(e) => setTelefoneTeste(e.target.value)}/>
                            <button type="submit" className="btn btn-sm btn-success" disabled={enviandoTeste}>
                                {enviandoTeste ? <span className="spinner-border spinner-border-sm"></span> : <><i className="bi bi-whatsapp"></i> Enviar teste</>}
                            </button>
                        </div>
                    </form>

                    <div className="secao-titulo"><i className="bi bi-sliders"></i> Robô e cadastro</div>

                    <div style={{display: "flex", gap: 16, flexWrap: "wrap", alignItems: "stretch", marginBottom: "1.2em"}}>
                        {/* Configuração do robô */}
                        {config &&
                            <form onSubmit={handleSalvarConfig} className="he-card form-mobile" style={{flex: "1 1 340px", minWidth: 0, display: "flex", flexDirection: "column", gap: 12}}>
                                <h5 className="he-titulo he-dourado" style={{margin: 0}}><i className="bi bi-robot"></i> Robô de convites</h5>

                                <div className={`interruptor-linha ${config.ativa ? "ativo" : ""}`}
                                    role="switch" aria-checked={config.ativa} tabIndex={0}
                                    onClick={() => setConfig({...config, ativa: !config.ativa})}
                                    onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setConfig({...config, ativa: !config.ativa}); } }}
                                    title={config.ativa ? "Toque para pausar" : "Toque para ativar"}>
                                    <div className="interruptor"></div>
                                    <span className="interruptor-texto">
                                        {config.ativa ? "Prospecção ativa" : "Prospecção pausada"}
                                        <span className="interruptor-apoio">
                                            {config.limiteDia ?? 10} convites/dia · {config.horaInicio || "09:00"} às {config.horaFim || "18:00"}
                                        </span>
                                    </span>
                                </div>

                                <div style={{display: "flex", gap: 10, flexWrap: "wrap"}}>
                                    <div style={{flex: "1 1 140px", minWidth: 0}}>
                                        <label className="form-label" style={{fontSize: "0.8em"}}>Convites por dia</label>
                                        <input className="form-control form-control-sm" type="number" min="1" max="100"
                                            value={config.limiteDia ?? 10}
                                            onChange={(e) => setConfig({...config, limiteDia: Number(e.target.value)})} required/>
                                    </div>
                                    <div style={{flex: "1 1 140px", minWidth: 0}}>
                                        <label className="form-label" style={{fontSize: "0.8em"}}>Começa às</label>
                                        <input className="form-control form-control-sm" type="time"
                                            value={config.horaInicio || "09:00"}
                                            onChange={(e) => setConfig({...config, horaInicio: e.target.value})} required/>
                                    </div>
                                    <div style={{flex: "1 1 140px", minWidth: 0}}>
                                        <label className="form-label" style={{fontSize: "0.8em"}}>Até às</label>
                                        <input className="form-control form-control-sm" type="time"
                                            value={config.horaFim || "18:00"}
                                            onChange={(e) => setConfig({...config, horaFim: e.target.value})} required/>
                                    </div>
                                </div>

                                <div>
                                    <label className="form-label" style={{fontSize: "0.8em"}}>Mensagem extra (opcional, entra no fim do convite)</label>
                                    <textarea className="form-control form-control-sm" rows={2}
                                        placeholder="Ex: Essa semana a análise sai na hora 😉"
                                        value={config.mensagemExtra || ""}
                                        onChange={(e) => setConfig({...config, mensagemExtra: e.target.value})}/>
                                </div>

                                <div>
                                    <label className="form-label" style={{fontSize: "0.8em"}}>Imagem do convite (opcional — vai junto da mensagem)</label>
                                    <div style={{display: "flex", gap: 10, alignItems: "flex-start", flexWrap: "wrap"}}>
                                        {config.imagemUrl &&
                                            <div style={{position: "relative"}}>
                                                <img src={config.imagemUrl} alt="arte do convite"
                                                    style={{width: 92, height: 92, objectFit: "cover", borderRadius: 10, border: "2px solid #d4af37"}}/>
                                                <button type="button" title="Remover imagem" aria-label="Remover imagem"
                                                    onClick={() => setConfig({...config, imagemUrl: "", imagemNome: ""})}
                                                    style={{position: "absolute", top: -10, right: -10, width: 32, height: 32, borderRadius: "50%",
                                                        border: "2px solid #16233a", background: "#ff6b6b", color: "#fff", cursor: "pointer",
                                                        lineHeight: 1, fontSize: 18, fontWeight: 700, display: "grid", placeItems: "center",
                                                        boxShadow: "0 4px 12px rgba(0,0,0,0.4)"}}>×</button>
                                            </div>
                                        }
                                        <div style={{flex: "1 1 200px", minWidth: 0}}>
                                            <label className="btn btn-outline-he btn-sm btn-total-mobile" style={{margin: 0, cursor: "pointer", overflowWrap: "break-word"}}>
                                                <i className="bi bi-image"></i> {config.imagemNome || (config.imagemUrl ? "Trocar imagem" : "Escolher imagem")}
                                                <input type="file" accept="image/png,image/jpeg,image/webp" style={{display: "none"}}
                                                    onChange={(e) => {
                                                        const arquivo = e.target.files?.[0];
                                                        e.target.value = "";
                                                        if (!arquivo) return;
                                                        // 900 KB: acima disso o WhatsApp demora e a linha do robô engasga
                                                        if (arquivo.size > 900 * 1024) {
                                                            setErroPadrao(new Error("Imagem muito pesada. Use uma de até 900 KB."));
                                                            return;
                                                        }
                                                        const leitor = new FileReader();
                                                        leitor.onload = () => setConfig({...config, imagemUrl: String(leitor.result || ""), imagemNome: arquivo.name});
                                                        leitor.readAsDataURL(arquivo);
                                                    }}/>
                                            </label>
                                            <p style={{color: "#a3aec0", fontSize: "0.78rem", lineHeight: 1.45, margin: "8px 0 0"}}>
                                                PNG, JPG ou WEBP até 900 KB. A arte vai como foto, com o convite na legenda.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <button type="submit" className="btn btn-he" disabled={salvandoConfig}>
                                    {salvandoConfig ? <span className="spinner-border spinner-border-sm"></span> : <><i className="bi bi-check-lg"></i> Salvar</>}
                                </button>
                                <p style={{color: "#a3aec0", fontSize: "0.78rem", lineHeight: 1.45, margin: 0}}>
                                    <i className="bi bi-info-circle"></i> Envios só de segunda a sábado, com aquecimento automático nos primeiros dias.
                                </p>
                            </form>
                        }

                        {/* Adicionar lead */}
                        <form onSubmit={handleAdicionar} className="he-card form-mobile" style={{flex: "1 1 280px", minWidth: 0, display: "flex", flexDirection: "column", gap: 10}}>
                            <h5 className="he-titulo he-dourado" style={{margin: 0}}><i className="bi bi-person-plus"></i> Adicionar lead</h5>
                            <div>
                                <label className="form-label" style={{fontSize: "0.8em"}}>Nome do negócio</label>
                                <input className="form-control form-control-sm" placeholder="Ex: Salão da Mari"
                                    value={novoLead.nome} onChange={(e) => setNovoLead({...novoLead, nome: e.target.value})} required/>
                            </div>
                            <div>
                                <label className="form-label" style={{fontSize: "0.8em"}}>Telefone (WhatsApp)</label>
                                <input className="form-control form-control-sm" placeholder="47 99999-9999"
                                    value={novoLead.telefone} onChange={(e) => setNovoLead({...novoLead, telefone: e.target.value})} required/>
                            </div>
                            <div style={{display: "flex", gap: 10, flexWrap: "wrap"}}>
                                <div style={{flex: "1 1 180px", minWidth: 0}}>
                                    <label className="form-label" style={{fontSize: "0.8em"}}>Nicho</label>
                                    <select className="form-select form-select-sm" value={novoLead.nicho}
                                        onChange={(e) => setNovoLead({...novoLead, nicho: e.target.value})}>
                                        {NICHOS.map((n) => <option key={n} value={n}>{n}</option>)}
                                    </select>
                                </div>
                                <div style={{flex: "1 1 180px", minWidth: 0}}>
                                    <label className="form-label" style={{fontSize: "0.8em"}}>Cidade</label>
                                    <input className="form-control form-control-sm"
                                        value={novoLead.cidade} onChange={(e) => setNovoLead({...novoLead, cidade: e.target.value})} required/>
                                </div>
                            </div>
                            <button type="submit" className="btn btn-he" style={{marginTop: "auto"}} disabled={adicionando}>
                                {adicionando ? <span className="spinner-border spinner-border-sm"></span> : <><i className="bi bi-plus-lg"></i> Adicionar</>}
                            </button>
                        </form>

                        {/* Importar em massa */}
                        <div className="he-card form-mobile" style={{flex: "1 1 280px", minWidth: 0, display: "flex", flexDirection: "column", gap: 10}}>
                            <h5 className="he-titulo he-dourado" style={{margin: 0}}><i className="bi bi-cloud-upload"></i> Importar em massa</h5>
                            <p style={{color: "#a3aec0", fontSize: "0.85rem", lineHeight: 1.5, margin: 0}}>
                                Escolha um arquivo <strong>CSV</strong> (exportado do Excel, Google Sheets ou Cristal Leads) ou cole a lista abaixo.
                                Pode colar do jeito que sair do Cristal: se a primeira linha for o cabeçalho, a ordem das colunas não importa —
                                eu acho <em>Nome</em>, <em>WhatsApp/Telefone</em>, <em>Tipo/Nicho</em> e <em>Cidade</em> sozinha.
                                Sem cabeçalho, uso a ordem <em>Nome, Telefone, Nicho, Cidade</em>. Telefone fixo é descartado (não recebe WhatsApp).
                            </p>

                            <label className="btn btn-outline-he" style={{margin: 0, cursor: "pointer", overflowWrap: "break-word"}}>
                                <i className="bi bi-filetype-csv"></i> {nomeArquivo || "Escolher arquivo CSV"}
                                <input type="file" accept=".csv,.txt,text/csv" style={{display: "none"}}
                                    onChange={(e) => {
                                        const arquivo = e.target.files?.[0];
                                        if (!arquivo) return;
                                        setNomeArquivo(arquivo.name);
                                        setResultadoImport("");
                                        const leitor = new FileReader();
                                        leitor.onload = () => setTextoImport(String(leitor.result || ""));
                                        // planilha brasileira costuma vir em ISO-8859-1; o UTF-8 cobre o resto
                                        leitor.readAsText(arquivo, "UTF-8");
                                        e.target.value = "";
                                    }}/>
                            </label>

                            <textarea className="form-control form-control-sm" rows={6} style={{flex: 1}}
                                placeholder={"Nome; Telefone; Nicho; Cidade (um por linha)"}
                                value={textoImport} onChange={(e) => { setTextoImport(e.target.value); setNomeArquivo(""); }}/>
                            <button type="button" className="btn btn-he" onClick={handleImportar} disabled={importando || !textoImport.trim()}>
                                {importando ? <span className="spinner-border spinner-border-sm"></span> : <><i className="bi bi-cloud-upload"></i> Importar {textoImport.trim() ? `(${textoImport.split(/\r?\n/).filter((l) => l.trim()).length} linhas)` : ""}</>}
                            </button>
                            {resultadoImport &&
                                <p className="he-dourado" style={{fontSize: "0.85em", fontWeight: 700, margin: 0}}>
                                    <i className="bi bi-check-circle"></i> {resultadoImport}
                                </p>
                            }
                        </div>
                    </div>

                    {/* Lista de leads */}
                    <div className="secao-titulo"><i className="bi bi-people"></i> Leads</div>
                    <div className="he-card sem-rolagem">
                        <div style={{display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center", marginBottom: "1em"}}>
                            <h5 className="he-titulo he-dourado" style={{margin: 0}}><i className="bi bi-people"></i> Leads</h5>
                            <span style={{marginLeft: "auto", color: "#a3aec0", fontSize: "0.85rem", fontWeight: 600}}>
                                {visiveis.length} de {leads.length}
                            </span>
                            <select className="form-select form-select-sm" style={{width: "auto", maxWidth: 260}}
                                value={filtroNicho} onChange={(e) => setFiltroNicho(e.target.value)} title="Filtrar por nicho">
                                <option value="">Todos os nichos ({leads.length})</option>
                                {nichosDisponiveis.map(([n, q]) => <option key={n} value={n}>{n} ({q})</option>)}
                            </select>
                            <input className="form-control form-control-sm" style={{width: "100%", maxWidth: 240}}
                                placeholder="Buscar nome, telefone ou nicho..."
                                value={busca} onChange={(e) => setBusca(e.target.value)}/>
                            {filtroNicho &&
                                <button className="btn btn-sm btn-outline-he" onClick={() => setFiltroNicho("")}>
                                    {filtroNicho} <i className="bi bi-x-lg"></i>
                                </button>
                            }
                            {filtroStatus &&
                                <button className="btn btn-sm btn-outline-he" onClick={() => setFiltroStatus(null)}>
                                    {STATUS.find((s) => s.valor === filtroStatus)?.plural} <i className="bi bi-x-lg"></i>
                                </button>
                            }
                        </div>

                        <div style={{
                            display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center",
                            background: "#d4af370f", border: "1px solid #d4af3733", borderRadius: 10,
                            padding: "8px 12px", margin: "0 0 12px",
                        }}>
                            <span style={{fontSize: "0.86rem", color: "#c9d3e0"}}>
                                <i className="bi bi-send-check he-dourado"></i>{" "}
                                <strong className="he-dourado">{marcadosPendentes}</strong> marcado(s) na fila de convite
                                {config?.limiteDia ? <span style={{color: "#8b97a8"}}> · saem até {config.limiteDia}/dia</span> : null}
                            </span>
                            <div style={{marginLeft: "auto", display: "flex", gap: 8, flexWrap: "wrap"}}>
                                <button className="btn btn-sm btn-he" disabled={marcando || !pendentesVisiveis}
                                    onClick={() => marcarVisiveis(true)}>
                                    <i className="bi bi-check2-all"></i> Marcar os {pendentesVisiveis} desta lista
                                </button>
                                <button className="btn btn-sm btn-outline-he" disabled={marcando || !pendentesVisiveis}
                                    onClick={() => marcarVisiveis(false)}>
                                    <i className="bi bi-x-lg"></i> Desmarcar
                                </button>
                            </div>
                        </div>

                        {visiveis.length === 0
                            ? <Vazio icone="bi bi-people" titulo={busca || filtroStatus ? "Nenhum lead nesse filtro" : "Nenhum lead por aqui"}
                                     texto={busca || filtroStatus
                                        ? "Limpe a busca ou o filtro de status para ver a lista inteira."
                                        : "Adicione um lead no formulário acima ou importe uma lista CSV 💛"}/>
                            : <div className="table-responsive rolagem-so-desktop">
                                <table className="table table-hover tabela-responsiva tabela-ampla">
                                    <thead>
                                        <tr>
                                            <th style={{width: 42, textAlign: "center"}} title="Marcar para receber convite">
                                                <i className="bi bi-send-check" style={{color: "#d4af37"}}></i>
                                            </th>
                                            <th>Nome</th>
                                            <th>Telefone</th>
                                            <th>Nicho</th>
                                            <th>Cidade</th>
                                            <th>Status</th>
                                            <th>Enviado em</th>
                                            <th style={{textAlign: "right"}}>Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {visiveisPagina.map((l) => (
                                            <tr key={l.id} style={l.selecionado ? {background: "#d4af3712"} : undefined}>
                                                <td data-rotulo="Convite" style={{textAlign: "center"}}>
                                                    <input type="checkbox" className="form-check-input"
                                                        style={{cursor: l.status === "pendente" ? "pointer" : "not-allowed", width: 18, height: 18}}
                                                        checked={!!l.selecionado}
                                                        disabled={l.status !== "pendente" || marcando}
                                                        title={l.status === "pendente" ? "Marcar pra receber convite" : "Só quem está pendente entra na fila"}
                                                        onChange={(e) => alternarSelecao(l, e.target.checked)}/>
                                                </td>
                                                <td className="principal" data-rotulo="Nome" style={{fontWeight: 600}}>
                                                    {l.nome}
                                                    {l.observacao && <div style={{color: "#a3aec0", fontSize: "0.82rem", fontWeight: 400, lineHeight: 1.4, marginTop: 2}}>{l.observacao}</div>}
                                                </td>
                                                <td data-rotulo="Telefone">
                                                    <a className="he-dourado" style={{textDecoration: "none", whiteSpace: "nowrap"}} target="_blank" rel="noreferrer"
                                                        href={linkWhatsApp(l.telefone, `Olá! Aqui é da Help Empresarial 😊`)}>
                                                        <i className="bi bi-whatsapp"></i> {l.telefone}
                                                    </a>
                                                </td>
                                                <td data-rotulo="Nicho">{l.nicho}</td>
                                                <td data-rotulo="Cidade">{l.cidade}</td>
                                                <td data-rotulo="Status">
                                                    <span className="badge" style={{
                                                        background: corDoStatus(l.status) + "22",
                                                        color: corDoStatus(l.status),
                                                        border: `1px solid ${corDoStatus(l.status)}66`,
                                                        whiteSpace: "nowrap",
                                                    }}>
                                                        {rotuloDoStatus(l.status)}
                                                    </span>
                                                </td>
                                                <td data-rotulo="Enviado em">{l.enviadoEm ? dataBR(l.enviadoEm) : "—"}</td>
                                                <td className="acoes">
                                                    <div className="acoes-linha" style={{justifyContent: "flex-end"}}>
                                                        {l.status === "descartado"
                                                            ? <button className="btn btn-sm btn-outline-he" title="Voltar pra fila"
                                                                onClick={() => mudarStatus(l, "pendente")}>
                                                                <i className="bi bi-arrow-counterclockwise"></i> Reativar
                                                            </button>
                                                            : <button className="btn btn-sm btn-outline-he" title="Tirar da fila sem excluir"
                                                                onClick={() => mudarStatus(l, "descartado")}>
                                                                <i className="bi bi-slash-circle"></i> Descartar
                                                            </button>
                                                        }
                                                        <button className="btn btn-sm btn-outline-danger" title="Excluir de vez"
                                                            onClick={() => handleExcluir(l)}>
                                                            <i className="bi bi-trash"></i><span className="so-mobile-inline"> Excluir</span>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {/* Paginação — pra não rolar 500 leads de uma vez */}
                                {totalPaginas > 1 &&
                                    <div style={{display: "flex", alignItems: "center", justifyContent: "center", gap: 14, padding: "14px 8px 4px", flexWrap: "wrap"}}>
                                        <button className="btn btn-outline-he" disabled={paginaAtual <= 1}
                                            onClick={() => setPagina((p) => Math.max(1, p - 1))}
                                            style={{opacity: paginaAtual <= 1 ? 0.4 : 1}}>
                                            <i className="bi bi-chevron-left"></i> Anterior
                                        </button>
                                        <span style={{color: "#c9d4e2", fontSize: "0.9rem", whiteSpace: "nowrap"}}>
                                            Página <strong className="he-dourado">{paginaAtual}</strong> de {totalPaginas}
                                            <span style={{color: "#8b97a8"}}> · {visiveis.length} leads</span>
                                        </span>
                                        <button className="btn btn-outline-he" disabled={paginaAtual >= totalPaginas}
                                            onClick={() => setPagina((p) => Math.min(totalPaginas, p + 1))}
                                            style={{opacity: paginaAtual >= totalPaginas ? 0.4 : 1}}>
                                            Próxima <i className="bi bi-chevron-right"></i>
                                        </button>
                                    </div>
                                }
                            </div>
                        }

                        {/* Enviar agora: não espera a janela da manhã */}
                        <div style={{
                            display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center",
                            justifyContent: "space-between", marginTop: 16, paddingTop: 16,
                            borderTop: "1px solid #ffffff14",
                        }}>
                            <div style={{fontSize: "0.86rem", color: "#9aa5b5", maxWidth: 520}}>
                                {marcadosPendentes
                                    ? <>Vou convidar <strong className="he-dourado">{marcadosPendentes}</strong> empresa(s) marcada(s), uma de cada vez, com alguns minutos entre elas.</>
                                    : <>Marque as empresas na lista acima pra liberar o envio.</>}

                                <div style={{display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center", marginTop: 10}}>
                                    <span style={{color: "#8b97a8"}}>Como mandar:</span>
                                    {MODOS_ENVIO.map((m) => (
                                        <button key={m.valor}
                                            className={`btn btn-sm ${(config?.modoEnvio || "misto") === m.valor ? "btn-he" : "btn-outline-he"}`}
                                            style={{padding: "2px 10px", fontSize: "0.8rem"}}
                                            disabled={salvandoModo}
                                            title={m.dica}
                                            onClick={() => mudarModoEnvio(m.valor)}>
                                            <i className={m.icone}></i> {m.rotulo}
                                        </button>
                                    ))}
                                </div>
                                {!config?.imagemUrl && (config?.modoEnvio || "misto") !== "texto" &&
                                    <div style={{color: "#e0a800", marginTop: 6, fontSize: "0.82rem"}}>
                                        <i className="bi bi-exclamation-triangle"></i> Sem arte carregada aqui em cima, o convite sai só em texto.
                                    </div>
                                }
                                {avisoDisparo && <div style={{color: "#2ecc71", marginTop: 6}}><i className="bi bi-check-circle"></i> {avisoDisparo}</div>}
                            </div>
                            <button className="btn btn-he" style={{minWidth: 230, fontWeight: 700}}
                                disabled={!marcadosPendentes || disparando}
                                onClick={handleDisparar}>
                                {disparando
                                    ? <><span className="spinner-border spinner-border-sm"></span> Pedindo...</>
                                    : <><i className="bi bi-send-fill"></i> Enviar convite{marcadosPendentes === 1 ? "" : "s"} agora{marcadosPendentes ? ` (${marcadosPendentes})` : ""}</>}
                            </button>
                        </div>
                    </div>

                    {/* Buscar direto na base do Cristal Leads */}
                    <div className="he-card" style={{marginTop: 18}}>
                        <h3 className="he-subtitulo" style={{marginTop: 0}}>
                            <i className="bi bi-gem he-dourado"></i> Buscar na base do <span className="he-dourado">Cristal</span>
                        </h3>
                        <p style={{color: "#9aa5b5", fontSize: "0.88rem", marginBottom: 14}}>
                            Puxa empresas com WhatsApp direto da base e já cadastra como lead, <strong>desmarcadas</strong> — você escolhe quem recebe convite.
                        </p>
                        <div style={{display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end"}}>
                            <div>
                                <label className="form-label" style={{fontSize: "0.8rem", color: "#9aa5b5"}}>Nicho</label>
                                <input className="form-control form-control-sm" style={{width: 190}} placeholder="padaria, salão, oficina..."
                                    value={filtrosCristal.nicho}
                                    onChange={(e) => setFiltrosCristal({...filtrosCristal, nicho: e.target.value})}/>
                            </div>
                            <div>
                                <label className="form-label" style={{fontSize: "0.8rem", color: "#9aa5b5"}}>Cidade</label>
                                <input className="form-control form-control-sm" style={{width: 190}} placeholder="Itajaí"
                                    value={filtrosCristal.cidade}
                                    onChange={(e) => setFiltrosCristal({...filtrosCristal, cidade: e.target.value})}/>
                            </div>
                            <div>
                                <label className="form-label" style={{fontSize: "0.8rem", color: "#9aa5b5"}}>Estado</label>
                                <input className="form-control form-control-sm" style={{width: 80}} placeholder="SC" maxLength={2}
                                    value={filtrosCristal.uf}
                                    onChange={(e) => setFiltrosCristal({...filtrosCristal, uf: e.target.value.toUpperCase()})}/>
                            </div>
                            <div>
                                <label className="form-label" style={{fontSize: "0.8rem", color: "#9aa5b5"}}>Quantas</label>
                                <input className="form-control form-control-sm" style={{width: 100}} type="number" min={1} max={1000}
                                    value={filtrosCristal.limite}
                                    onChange={(e) => setFiltrosCristal({...filtrosCristal, limite: e.target.value})}/>
                            </div>
                            <button className="btn btn-sm btn-he" style={{height: 31}}
                                disabled={buscandoCristal || (!filtrosCristal.nicho && !filtrosCristal.cidade && !filtrosCristal.uf)}
                                onClick={handleBuscarCristal}>
                                {buscandoCristal
                                    ? <><span className="spinner-border spinner-border-sm"></span> Buscando...</>
                                    : <><i className="bi bi-search"></i> Buscar e cadastrar</>}
                            </button>
                        </div>
                        {resultadoCristal &&
                            <div style={{marginTop: 12, color: "#2ecc71", fontSize: "0.88rem"}}>
                                <i className="bi bi-check-circle"></i> {resultadoCristal}
                            </div>
                        }
                    </div>
                </>
            }
        </div>
    )
}
